/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Q&A module
define('modules/QuestionAndAnswer/QuestionAndAnswer',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var apiUrl;
    var currentProductId;
    var pagination;

    var form = {
        "QA": {
            Fields: [
                { "Name": 'Name', "Field": '#qa_name', "Param": 'QuestionFromName', "Type": 'Text', "Validators": [{ "Type": 'WhiteSpace' }] },
                { "Name": 'Email', "Field": '#qa_email', "Param": 'QuestionFromEmail', "Type": 'Text', "Validators": [{ "Type": 'Email' }] },
                { "Name": 'Question', "Field": '#qa_question', "Param": 'Question', "Type": 'Text', "Validators": [{ "Type": 'WhiteSpace' }] }
            ],
            Validate: true
        }
    };

    var btns = {
        submitQuestion: '#submitQuestionBtn'
    };

    function truncateDescriptions() {
        var content = $('#qaList .qaDescription');
        if (content && content.length > 0) {
            content.truncate({ max_length: 420, more: 'More', less: 'Hide' });
        }
    }

    function hideQuestionForm() {
        $('#askQuestionBox').find('span').removeClass('icon-minus-circle');
        $('#askQuestionForm').removeClass('expanded');
    }

    function clearForm() {
        $('#qa_name').val('');
        $('#qa_email').val('');
        $('#qa_question').val('');
    }

    function submitQuestion() {
        var isValid = Roc.Validation.validateForm(form.QA);

        if (isValid) {
            Roc.Core.lockButton(btns.submitQuestion);
            $.ajax({
                url: apiUrl + "/api/questionanswer/" + currentProductId,
                dataType: "json",
                contentType: "application/json",
                type: "POST",
                data: JSON.stringify(Roc.Validation.getFieldValues(form.QA))
            }).done(function () {
                hideQuestionForm();
                clearForm();

                Roc.UI.template('infoBox-Tmp', {
                    id: 'qaThankYou',
                    title: 'Thank you for submitting your question',
                    content: 'It will appear when it is answered and approved.'
                }).then(function (renderedTemplate) {
                    $(renderedTemplate).insertAfter('#askQuestionForm');
                });
            }).fail(function () {
                Roc.UI.displayErrorPopup('There was an error while trying to submit this question, please try again.');
            }).always(function () {
                Roc.Core.releaseLockedButton(btns.submitQuestion);
            });
        }
    }

    function bindWidget(viewModel, paging) {
        if (viewModel) {
            Roc.UI.template('qaList-Tmp', viewModel).then(function (renderedTemplate) {
                $('#qaList').replaceWith(renderedTemplate);
                truncateDescriptions();
                updateControls(viewModel, paging);
            });
        }
    }

    function updateControls(data, paging) {
        var totalItems = 0;

        if (data && data.totalCount !== null) {
            totalItems = parseInt(data.totalCount);
        }

        var startIndex = (paging.page - 1) * paging.pageSize + 1;
        if (startIndex === 0) {
            startIndex = 1;
        }
        var endIndex = startIndex + paging.pageSize - 1;
        if (endIndex > totalItems) {
            endIndex = totalItems;
        }

        $('#qaWidgetHeader span.startIndex').text(startIndex);
        $('#qaWidgetHeader span.endIndex').text(endIndex);
        $('#qaPage').val(paging.page);

    }

    function reloadWidget(pg) {
        if (typeof pg == 'undefined') {
            pg = pagination;
        }

        $.get(
            apiUrl + '/api/questionanswer/' + currentProductId + '/' + pg.pageSize + '/' + pg.page,
            function (data) {
                bindWidget(data, pg);
            }
		);
    }

    function bindEvents() {
        submitQuestionEvt();
    }

    function submitQuestionEvt() {
        $(document).on('click', btns.submitQuestion, function () {
            submitQuestion();
        });

        $(document).on('click', '#askQuestionBox.contentBoxHeader', function () {
            //remove thank you message from previous request
            $('#askQuestionForm + #qaThankYou').remove();
        });
    }

    function init(viewModel) {
        var cfg = window.RocConfig;
        apiUrl = cfg.api.baseRocApiUrl;
        currentProductId = viewModel.productId;
        pagination = Roc.Pagination.init({
            page: viewModel.currentPage,
            pageSize: viewModel.pageSize,
            totalPages: viewModel.totalPages,
            prefix: '#qaWidgetHeader'
        }, reloadWidget);

        bindWidget(viewModel, pagination);
        bindEvents();
    }

    // public methods
    var QuestionAndAnswer = {
        init: init
    };

    Roc.Logger.debug('QuestionAndAnswer.js Loaded:', QuestionAndAnswer);

    // return public methods
    return QuestionAndAnswer;
});
